import { Component, OnInit } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { MatDialog } from '@angular/material/dialog';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { AuthService } from 'app/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-oldglass',
  templateUrl: './oldglass.component.html',
  styleUrls: ['./oldglass.component.scss']
})
export class OldglassComponent implements OnInit {
  destroyold$: Subject<boolean> = new Subject<boolean>();
  selectValue: any;
  constructor(private emrservice: EMRService,private authservice: AuthService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.emrservice.enabledisablepog =true;
  }
  getsphvalue(category: string, valuebox: string) {  
    this.emrservice.ar_value_box = valuebox;
    this.emrservice.eyechkcategory = category;
  
    const dialogRef = this.dialog.open(EyecheckComponent, {
      panelClass: 'full-width-dialog',
      minHeight: '200px',
    
  
    });
  
    dialogRef.afterClosed().pipe(takeUntil(this.destroyold$)).subscribe(result => {     
     this.emrservice.enabledisablepog =false;
    });
  }
  anesthTpyePOpup(type) {
  
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }
    });
     dialogRef.afterClosed().pipe(takeUntil(this.destroyold$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisablepog =false;
        this.emrservice.autoref.glassUsedRemarks =result;
      }
    });
  }
  refReasonPOpup(parameter,type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyold$)).subscribe(result => {
      if (result != 0) {
       
        if(type ==1){
          this.emrservice.enabledisablepog =false;
          this.emrservice.autoref.glassUsedType=result;
        }

      }
    });
  }
  refhelplistPOpup(type, value){
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
       width: '33%',
      data: {
          typeid: type
      }

    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroyold$)).subscribe(result => {
        if(result !=0){
          this.emrservice.enabledisablepog =false;
          this.selectValue = result;
          this.set_ar_oldglass_values(value);
        }
    });
  }
  set_ar_oldglass_values(row){
    this.emrservice.enabledisablepog =false;
    switch (row) {
    
      // right eye
      case "r_og_r1_c1": {
        this.emrservice.autoref.odSph = this.selectValue;
        
            break;
      }
      case "r_og_r1_c2": {
        this.emrservice.autoref.odCyl = this.selectValue;
        
            break;
      }
      case "r_og_r1_c3": {
        this.emrservice.autoref.odAxis = this.selectValue;
        
            break;
      }
      case "r_og_r1_c4": {
        this.emrservice.autoref.odDbscva = this.selectValue;
        
            break;
      }
      case "r_og_r2_c1": {
        this.emrservice.autoref.odAdd = this.selectValue;
        
            break;
      }
      case "r_og_r2_c2": {
        this.emrservice.autoref.odBscva = this.selectValue;
        
            break;
      }
  
      //left eye
      case "l_og_r1_c1": {
        this.emrservice.autoref.osSph = this.selectValue;
        
            break;
      }
      case "l_og_r1_c2": {
        this.emrservice.autoref.osCyl = this.selectValue;
        
            break;
      }
      case "l_og_r1_c3": {
        this.emrservice.autoref.osAxis = this.selectValue;
        
            break;
      }
      case "l_og_r1_c4": {
        this.emrservice.autoref.osDbscva = this.selectValue;
        
            break;
      }
      case "l_og_r2_c1": {
        this.emrservice.autoref.osAdd = this.selectValue;
        
            break;
      }
      case "l_og_r2_c2": {
        this.emrservice.autoref.osBscva = this.selectValue;
        
            break;
      }
    }
  }
  checkPOG($event){
    this.emrservice.enabledisablepog=false;
  }
  
  ngOnDestroy():void {
    this.destroyold$.next(true);
    this.destroyold$.unsubscribe();
  }
}
